import { ShipmentRequestModel } from "api/lokiRequestModels/shipments/ShipmentRequestModel";
import clsx from "clsx";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useStore } from "store/StoreConfigs";
import { shipmentViewStyles } from "./ShipmentViewStyles";

export const ShipmentView = observer(function ShipmentView() {
    const classes = shipmentViewStyles();
    const { identityStore, shipmentViewStore, commonStore } = useStore();

    const { shipmentId } = useParams<any>();

    useEffect(() => {
        const request: ShipmentRequestModel = {
            customerId: identityStore.currentCustomerId,
            id: shipmentId,
        };

        shipmentViewStore.loadShipment(request);
    }, []);

    useEffect(() => {
        commonStore.setCurrentView("shipment");
    }, []);

    return <main className={clsx(classes.content)}></main>;
});
